import Index from "./index.vue"
import Dashboard from "./views/Dashboard.vue"
import Profile from "./views/Profile.vue"
import Create from "./components/Create.vue"

export default [
  {
    path: "/location",
    name: "location",
    component: Index,
    title: "Location",
    children: [
      {
        path: "",
        name: "location-dashboard",
        component: Dashboard,
      },
      {
        path: "dashboard",
        name: "location-dashboard-legacy",
        redirect: { name: "location-dashboard" },
      },
      {
        path: ":id/profile",
        name: "location-profile",
        component: Profile,
        props: true,
      },
      {
        path: "list",
        name: "location-list",
        redirect: { name: "location-dashboard" },
      },
      {
        path: "create",
        name: "location-create",
        component: Create,
      },
    ],
  },
]
